<template>
  <div>
    <div class="row text-center">
      <div class="col-sm-12 col-xs-12">
        <h5> {{ title }} </h5>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="text-center">
            <div class="col-xs-12"
                :class="this.adaptiveGridSystem.mdColumnOrders"
              v-if="this.$store.state.configs['ALLOW_REGISTRATION'] && this.$store.state.configs['DISPLAY_NEW_ORDER_ACCOUNT']"
            >
              <div class="bg-green-light grid-content" :class="buttonClicked === true || sitecode === false || firstRegistration === true ? 'disabled' : ''">
                <p class="text-center">
                  <i class="el-icon-document-add icon icon-green text-center"></i>
                </p>
                <p class="w-90">
                  {{ computeCaption(fields_en['place_a_new_order_and_let_the_lab_you_are_going_for_collection'], this.$store.state.lang.value.toLowerCase())}}
                </p>
                <div class="text-center">
                  <router-link
                    role="link"
                    to="/patient/account/form/registration"
                    tag="button"
                    class="btn btn-default dashboard-button"
                    @click.native="buttonClick()"
                    :disabled="buttonClicked === true || sitecode === false || firstRegistration  === true"
                    :class="[sitecode === false ? 'disabled' : '']"
                    v-html="
                       computeCaption(fields_en['new_order'], this.$store.state.lang.value.toLowerCase())
                    "
                  >
                  </router-link>
                </div>
              </div>
            </div>

            <div class="col-xs-12"
                :class="this.adaptiveGridSystem.mdColumnKit"
              v-if="this.$store.state.configs['ALLOW_KIT_REGISTRATION'] && this.$store.state.configs['DISPLAY_KIT_ACCOUNT']"
            >
              <div class="kit-background grid-content" :class="buttonClicked === true || sitecode === false || firstRegistration  === true ? 'disabled' : ''">
                <p class="text-center">
                  <i class="el-icon-box icon icon-kit text-center"></i>
                </p>
                <p class="w-90">{{ computeCaption(fields_en['did_you_receive_at_home_collection_kit_scan_here_the_barcode'], this.$store.state.lang.value.toLowerCase())}}</p>
                <div class="text-center">
                  <router-link
                    role="link"
                    to="/patient/kit"
                    tag="button"
                    class="btn btn-default dashboard-button kit-button"
                    @click.native="buttonClick()"
                    :disabled="buttonClicked === true || sitecode === false || firstRegistration  === true"
                    :class="[sitecode === false ? 'disabled' : '']"
                    v-html="
                      computeCaption(fields_en['register_kit'], this.$store.state.lang.value.toLowerCase())
                    "
                  >
                  </router-link>
                </div>
              </div>
            </div>
            <div class="col-xs-12"
                :class="this.adaptiveGridSystem.mdColumnResults"
              v-if="this.$store.state.configs['ALLOW_RESULTS'] && this.$store.state.configs['DISPLAY_RESULTS_ACCOUNT']"
            >
              <div class="results-background grid-content" :class="buttonClicked === true || sitecode === false || firstRegistration === true ? 'disabled' : ''">
                <p class="text-center">
                  <i class="el-icon-document-checked icon icon-results"></i>
                </p>
                <p class="w-90">{{computeCaption(fields_en['here_you_can_check_all_the_results_for_you_and_your_dependents'], this.$store.state.lang.value.toLowerCase())}}</p>
                <div class="text-center">
                  <router-link
                    role="link"
                    to="/patient/account/results"
                    tag="button"
                    class="btn btn-default dashboard-button results-button"
                    @click.native="buttonClick()"
                    :disabled="buttonClicked === true || sitecode === false || firstRegistration === true"
                    :class="[sitecode === false ? 'disabled' : '']"
                    v-html="
                      computeCaption(fields_en['results'], this.$store.state.lang.value.toLowerCase())
                    "
                  >
                  </router-link>
                </div>
              </div>
            </div>
            <div class="col-xs-12"
                :class="this.adaptiveGridSystem.mdColumnDependents"
                v-if="this.$store.state.configs['ALLOW_REGISTRATION'] && this.$store.state.configs['DISPLAY_DEPENDENTS_ACCOUNT']">
              <div class="dependents-background grid-content"
                  :class="buttonClicked === true || sitecode === false || firstRegistration === true ? 'disabled' : ''">
                <p class="text-center">
                  <i class="el-icon-view icon icon-dependents text-center"></i>
                </p>
                <!-- <p class="text text-center">
                  Here you can add and edit your dependents to make faster
                  registrations
                </p> -->
                <!-- <p class="w-90">This is an example. This is an example</p> -->
                <p class="w-90">{{computeCaption(fields_en['add_or_modify_dependents_if_you_want_to_make_orders_for_them'], this.$store.state.lang.value.toLowerCase())}}</p>
                <div class="text-center">
                  <router-link
                    role="link"
                    to="/patient/account/dependents"
                    tag="button"
                    class="btn btn-default dashboard-button dependents-button"
                    @click.native="buttonClick()"
                    :disabled="buttonClicked === true || sitecode === false || firstRegistration === true"
                    :class="[sitecode === false ? 'disabled' : '']"
                    v-html="
                      computeCaption(fields_en['dependents'], this.$store.state.lang.value.toLowerCase())
                    "
                  >
                  </router-link>
                </div>
              </div>
            </div>
            <div class="col-xs-12"
                :class="this.adaptiveGridSystem.mdColumnPersonalData"
                v-if="this.$store.state.configs['ALLOW_REGISTRATION']">
              <div class="personal-data-background grid-content" :class="buttonClicked === true ? 'disabled' : ''">
                <p class="text-center">
                  <i class="el-icon-tickets icon icon-personal-data text-center"></i>
                </p>
                <!-- <h4 class="text-center">Edit your personal data</h4> -->
                <!-- <p class="text text-center">
                  Fill in your medical data for future registrations
                </p> -->
                <!-- <p class="text text-center">
                  Here you will add necessary data for registrations (e.g
                  name, address, gender, ethnicity)
                </p> -->
                <p class="w-90">{{computeCaption(fields_en['edit_medical_data_for_faster_order_filling'], this.$store.state.lang.value.toLowerCase())}}</p>
                <div class="text-center">
                  <router-link
                    role="link"
                    to="/patient/account/data"
                    tag="button"
                    class="btn btn-default dashboard-button personal-data-button mt-5"
                    @click.native="buttonClick()"
                    :disabled="buttonClicked"
                    v-html="
                      computeCaption(fields_en['edit_personal_data'], this.$store.state.lang.value.toLowerCase())
                    "
                  >
                  </router-link>
                </div>
              </div>
            </div>
            <div class="col-xs-12"
                :class="this.adaptiveGridSystem.mdColumnAccount">
              <div class="grid-content account-background" :class="buttonClicked === true ? 'disabled' : ''">
                <p class="text-center">
                  <i class="el-icon-user icon icon-account text-center"></i>
                </p>
                <p class="w-90-big-tile">{{computeCaption(fields_en['account_related'], this.$store.state.lang.value.toLowerCase())}}</p>
                <div class="text-center">
                  <router-link
                    role="link"
                    to="/patient/account/manage"
                    tag="button"
                    class="btn btn-default dashboard-button account-button mt-5"
                    @click.native="buttonClick()"
                    :disabled="buttonClicked"
                    v-html="
                    computeCaption(fields_en['manage_account'], this.$store.state.lang.value.toLowerCase())
                    "
                  >
                  </router-link>
                </div>
                <div class="text-center">
                  <router-link
                    role="link"
                    to="/"
                    tag="button"
                    class="btn btn-default dashboard-button logout-button"
                    @click.native="buttonClickLogOut()"
                    :disabled="buttonClicked"
                    v-html="
                    computeCaption(fields_en['log_out'], this.$store.state.lang.value.toLowerCase())
                    "
                  >
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    <br/>
  </div>
</template>

<script>
  import FirstStep from '../../Forms/Wizard/FirstStep.vue'
  import {TranslationsUtils} from '../../../../../utils/Translations'
  //   import axios from 'axios'
  export default {
    components: { FirstStep },
    mixins: [TranslationsUtils],
    data () {
      return {
        buttonClicked: false,
        sitecode: this.$store.state.sitecode,
        firstRegistration: this.$store.state.firstRegistration,
        errorData: '',
        adaptiveGridSystem: {
          mdColumnOrders: '',
          mdColumnKit: '',
          mdColumnResults: '',
          mdColumnDependents: '',
          mdColumnPersonalData: '',
          mdColumnAccount: ''
        },
        fields_en: {
          here_you_can_check_all_the_results_for_you_and_your_dependents: 'Here you can check all the results for you and your dependents',
          did_you_receive_at_home_collection_kit_scan_here_the_barcode: 'Did you receive at home collection kit? Scan here the barcode',
          place_a_new_order_and_let_the_lab_you_are_going_for_collection: 'Place a new order and let the lab you are going for collection',
          add_or_modify_dependents_if_you_want_to_make_orders_for_them: 'Add or modify dependents if you want to make orders for them',
          edit_medical_data_for_faster_order_filling: 'Edit medical data for faster order filling',
          account_related: 'Account related',
          dashboard: 'Dashboard',
          dependents: 'Dependents',
          edit_personal_data: 'Edit personal data',
          register_kit: 'Register kit',
          new_order: 'New Order',
          results: 'Results',
          manage_account: 'Manage your account',
          log_out: 'Log out'
        }
      }
    },
    methods: {
      buttonClick () {
        this.buttonClicked = true
      },
      buttonClickLogOut () {
        this.buttonClicked = true
        localStorage.clear()
      }
    },
    computed: {
      title () {
        return this.$store.state.configs.LAB_NAME
      }
    },
    beforeMount () {
      this.adaptiveGridSystem = this.$store.state.adaptiveGridSystem
    }
  }
</script>

<style lang="scss" scoped>
@import "../../../../../assets/sass/paper/_variables.scss";

// .grid-content-top {
//   margin-top: 10px;
//   border-radius: 10px;
//   min-height: 300px;
// }
button{
  white-space: normal !important;
  word-wrap: break-word;
  margin-bottom: 10px;
  width: 90%;
}

.w-90{
  width: 90%;
  margin: 0 auto;
  margin-bottom: 10px;
  min-height: 90px;
}

.w-90-big-tile{
  width: 90%;
  margin: 0 auto;
  margin-bottom: 10px;
}

.grid-content {
  margin-top: 15px !important;
  border-radius: 10px;
  min-height: 330px;
}

.disabled {
  background-color: lightgrey !important;
}

.disabled button{
  color: #1f1f1f !important;
}

.disabled button:hover{
  color: #1f1f1f !important;
}

.disabled p i {
  color: grey !important;
}

.icon {
  padding-top: 20px;
  font-size: 50px;
}

i {
  margin-top: 15px;
}

ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

li {
  padding-left: 10px;
}
.text {
  font-size: 15px;
}

@media screen and (max-width: 1200px) {
  .grid-content {
    margin-top: 30px;
    border-radius: 10px;
    min-height: 350px;
  }
  .w-90 {
    min-height: 130px;
  }
}

@media screen and (max-width: 1110px) {
  .grid-content {
    margin-top: 30px;
    border-radius: 10px;
    min-height: 380px;
  }
  .w-90 {
    min-height: 155px;
  }
}

@media screen and (max-width: 990px) {
  .display-mobile-none {
    display:none
  }
  .grid-content {
    margin-top: 30px;
    border-radius: 10px;
    min-height: 230px;
  }
  .w-90 {
    min-height: 20px;
  }
}
@media screen and (max-width: 310px) {
  .display-mobile-none {
    display:none
  }
  .grid-content {
    margin-top: 30px;
    border-radius: 10px;
    min-height: 340px;
  }
  .w-90 {
    min-height: 120px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Account/Dashboard/Dashboard.vue